import { openDB } from "idb";

const DB_NAME = "blogsDB";
const STORE_NAME = "blogs";

export const PAGE_SIZE = 10;

const openBlogDB = async () => {
  return openDB(DB_NAME, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: "id" });
      }
    },
  });
};

export const saveBlogsToDB = async (blogs: any[]) => {
  const db = await openBlogDB();
  const tx = db.transaction(STORE_NAME, "readwrite");
  const store = tx.objectStore(STORE_NAME);

  for (const blog of blogs) {
    await store.put(blog); // Always upsert (no duplicate check)
  }

  await tx.done;
};

export const getBlogsFromDB = async (): Promise<any[]> => {
  const db = await openBlogDB();
  return db.getAll(STORE_NAME);
};

export const getBlogsFromDBByPage = async (page: number): Promise<any[]> => {
  const allBlogs = await getBlogsFromDB();
  const start = (page - 1) * PAGE_SIZE;
  return allBlogs.slice(start, start + PAGE_SIZE);
};
